import { IconBase, IconComponent } from './BaseIcon';

export const Bold: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M26 2H6.79a4.43 4.43 0 0 0-4.43 4.42v4.73h4V6.42A.43.43 0 0 1 6.79 6h7.59v20.12H9.22v4h14.45v-4h-5.28V6H26a.43.43 0 0 1 .43.43v4.73h4V6.42A4.43 4.43 0 0 0 26 2z" />
  </IconBase>
);
